module.exports = "/assets/939125021f904b38d299421dfb1da27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4O.png
// module id = 2171
// module chunks = 0